// extracted by mini-css-extract-plugin
module.exports = {"body":"HelpSectionBody_body__BfvRm","body--animations":"HelpSectionBody_body--animations__11QLs"};